import { render, staticRenderFns } from "./foodora_general_tab.vue?vue&type=template&id=78b541b2&scoped=true&"
import script from "./foodora_general_tab.vue?vue&type=script&lang=js&"
export * from "./foodora_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b541b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b541b2')) {
      api.createRecord('78b541b2', component.options)
    } else {
      api.reload('78b541b2', component.options)
    }
    module.hot.accept("./foodora_general_tab.vue?vue&type=template&id=78b541b2&scoped=true&", function () {
      api.rerender('78b541b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/foodora/location/tabs/foodora_general_tab.vue"
export default component.exports